import dayjs from "dayjs";

export const MENU_UNIVERSITARIO_CATEGORY_ID = 16;
export const CAFETERIA_SEDE_ID = 1;

const toPositiveNumber = (value) => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const getVoucherTargetCategoryId = (voucher = {}) => {
  const tipo = String(voucher?.tipo || "")
    .trim()
    .toUpperCase();
  if (tipo === "CATEGORIA") {
    return Number(voucher?.idCategoria || voucher?.categoria?.id || 0) || null;
  }
  if (tipo === "PRODUCTO") {
    return (
      Number(voucher?.producto?.idCategoria || voucher?.producto?.categoriaProducto?.id || 0) ||
      null
    );
  }
  return null;
};

export const isVoucherCalificanteCafeteria = (
  voucher = {},
  { idSede = CAFETERIA_SEDE_ID, fecha = dayjs() } = {}
) => {
  if (Number(idSede || 0) !== CAFETERIA_SEDE_ID) return false;
  if (Number(voucher?.grupo?.idSede || 0) !== CAFETERIA_SEDE_ID) return false;
  if (voucher?.grupo?.estado !== "Activo" || voucher?.habilitado === false) return false;
  if (!voucher?.desde || !voucher?.hasta) return false;

  const fechaOperacion = dayjs(fecha).startOf("day");
  const desde = dayjs(voucher?.desde).startOf("day");
  const hasta = dayjs(voucher?.hasta).startOf("day");
  if (
    !fechaOperacion.isValid() ||
    !desde.isValid() ||
    !hasta.isValid() ||
    fechaOperacion.isBefore(desde) ||
    fechaOperacion.isAfter(hasta)
  ) {
    return false;
  }

  if (toPositiveNumber(voucher?.saldo) <= 0 || toPositiveNumber(voucher?.saldoDiario) <= 0) {
    return false;
  }

  const tipo = String(voucher?.tipo || "")
    .trim()
    .toUpperCase();
  if (tipo === "MONTO") return true;

  const idCategoria = getVoucherTargetCategoryId(voucher);
  if (!idCategoria || idCategoria === MENU_UNIVERSITARIO_CATEGORY_ID) return false;

  if (tipo === "CATEGORIA") return true;
  if (tipo === "PRODUCTO") {
    return Boolean(Number(voucher?.idProducto || voucher?.producto?.id || 0));
  }
  return false;
};

export const getVoucherDisponibleCafeteria = (voucher = {}) =>
  Math.min(toPositiveNumber(voucher?.saldo), toPositiveNumber(voucher?.saldoDiario));

export const isProductoCompatibleConVoucher = (producto = {}, voucher = null) => {
  if (!voucher) return true;
  const tipo = String(voucher?.tipo || "")
    .trim()
    .toUpperCase();
  if (tipo === "MONTO") return true;
  if (tipo === "PRODUCTO") {
    return Number(producto?.id || 0) === Number(voucher?.idProducto || voucher?.producto?.id || 0);
  }
  if (tipo === "CATEGORIA") {
    return (
      Number(producto?.categoriaProducto?.id || producto?.idCategoria || 0) ===
      Number(voucher?.idCategoria || voucher?.categoria?.id || 0)
    );
  }
  return false;
};

export const validarAgregadoConVoucher = ({
  voucher = null,
  carrito = [],
  producto = null,
  cantidad = 1,
} = {}) => {
  if (!voucher) return { permitido: true, mensaje: null };
  if (!producto || !isProductoCompatibleConVoucher(producto, voucher)) {
    return {
      permitido: false,
      mensaje: "El producto no es compatible con el voucher seleccionado.",
    };
  }

  const cantidadAgregar = Number(cantidad || 0);
  if (!Number.isFinite(cantidadAgregar) || cantidadAgregar <= 0) {
    return { permitido: false, mensaje: "La cantidad seleccionada no es válida." };
  }

  const disponibles = getVoucherDisponibleCafeteria(voucher);
  const activos = (carrito || []).filter((item) => !item?.eliminado);
  const tipo = String(voucher?.tipo || "")
    .trim()
    .toUpperCase();
  if (tipo === "MONTO") {
    return { permitido: true, mensaje: null };
  }
  const consumoActual = activos.reduce((total, item) => total + Number(item?.cantidad || 0), 0);
  const consumoAgregar = cantidadAgregar;

  if (consumoActual + consumoAgregar > disponibles + 0.0001) {
    return {
      permitido: false,
      mensaje: "La cantidad supera las unidades disponibles del voucher.",
    };
  }

  return { permitido: true, mensaje: null };
};
